"use client"; // Ensure it runs on the client side only

import { ColorSchemeScript } from "@mantine/core";

export default function ColorSchemeScriptClient() {
  return <ColorSchemeScript />;
}
